import { defineComponent as _defineComponent } from 'vue'
import { unref as _unref, renderList as _renderList, Fragment as _Fragment, openBlock as _openBlock, createElementBlock as _createElementBlock, createElementVNode as _createElementVNode, toDisplayString as _toDisplayString, resolveComponent as _resolveComponent, normalizeClass as _normalizeClass, normalizeStyle as _normalizeStyle, withCtx as _withCtx, createBlock as _createBlock, createVNode as _createVNode, resolveDirective as _resolveDirective, withDirectives as _withDirectives, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue"

const _withScopeId = n => (_pushScopeId("data-v-222d42d1"),n=n(),_popScopeId(),n)
const _hoisted_1 = ["src"]
const _hoisted_2 = { class: "text-center pt-3 mt-3" }
const _hoisted_3 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("img", { src: "/images/back-1.svg" }, null, -1))
const _hoisted_4 = { class: "text-center pt-3 mt-3" }
const _hoisted_5 = { class: "" }

import { ref, inject } from "vue";
import { isMobile } from "@/core/config/WindowConfig";


export default /*#__PURE__*/_defineComponent({
  __name: 'SelectTenantPage',
  setup(__props) {

const currentPage = inject<any>("currentPage");
const isSubmitting = inject<any>("isSubmitting");
const tenantsOptions = inject<any>("tenantsOptions");
const selectedTenant = inject<any>("selectedTenant");
const pages = inject<any>("pages");

const onSubmitLogin = inject<any>("onSubmitLogin");

const flagList = ref({
  1: "/images/flags/au.svg",
  10000: "/images/flags/earth.svg",
  10002: "/images/flags/mn.svg",
  10004: "/images/flags/vn.svg",
  10005: "/images/flags/jp.svg",
  10006: "/images/flags/hong-kong.svg",
});

const getFlagSrc = (id) => {
  return flagList.value[id] || "/images/flags/default.svg"; // Provide a default flag if id not found
};

const loginWithTenantId = async (tenantId: number) => {
  selectedTenant.value = tenantId;
  await onSubmitLogin();
};

return (_ctx: any,_cache: any) => {
  const _component_el_card = _resolveComponent("el-card")!
  const _directive_loading = _resolveDirective("loading")!

  return (_openBlock(), _createElementBlock("div", null, [
    _withDirectives((_openBlock(), _createElementBlock("div", {
      class: _normalizeClass(["d-flex justify-content-center flex-wrap", _unref(isMobile) ? 'gap-4' : 'gap-12'])
    }, [
      (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_unref(tenantsOptions), (item, index) => {
        return (_openBlock(), _createBlock(_component_el_card, {
          class: _normalizeClass(["w-150px", [
          _unref(isMobile) ? 'my-3' : '',
          _unref(isSubmitting) ? 'disabled-card' : 'cursor',
        ]]),
          "body-style": { padding: '40px' },
          key: index,
          onClick: ($event: any) => (_unref(isSubmitting) ? null : loginWithTenantId(item)),
          style: _normalizeStyle({ pointerEvents: _unref(isSubmitting) ? 'none' : 'auto' })
        }, {
          default: _withCtx(() => [
            _createElementVNode("img", {
              src: getFlagSrc(item),
              alt: "",
              class: "img-rounded"
            }, null, 8, _hoisted_1),
            _createElementVNode("div", _hoisted_2, [
              _createElementVNode("span", null, _toDisplayString(_ctx.$t("title.tenants." + item)), 1)
            ])
          ]),
          _: 2
        }, 1032, ["class", "onClick", "style"]))
      }), 128)),
      _createVNode(_component_el_card, {
        class: _normalizeClass(["w-150px", _unref(isSubmitting) ? 'disabled-card' : 'cursor']),
        onClick: _cache[0] || (_cache[0] = ($event: any) => (_unref(isSubmitting) ? null : (currentPage.value = _unref(pages).login))),
        "body-style": { padding: '40px' },
        style: _normalizeStyle({ pointerEvents: _unref(isSubmitting) ? 'none' : 'auto' })
      }, {
        default: _withCtx(() => [
          _hoisted_3,
          _createElementVNode("div", _hoisted_4, [
            _createElementVNode("span", _hoisted_5, _toDisplayString(_ctx.$t("action.back")), 1)
          ])
        ]),
        _: 1
      }, 8, ["class", "style"])
    ], 2)), [
      [_directive_loading, _unref(isSubmitting)]
    ])
  ]))
}
}

})